'use client'

import * as React from 'react'
import type { Condition, Variant } from '../types'
import { generateRenderingId } from '../utils/generate-rendering-id'
import { StaticVariantsRendererInline } from './renderer'

type GetInlineVariant = ({ conditionsMet }: { conditionsMet: boolean }) => Variant['content']

export const InlineStaticVariant = ({
  conditions,
  getVariant,
  className,
}: {
  conditions: Condition[]
  getVariant: GetInlineVariant
  className?: string
}) => {
  const renderingIdRef = React.useRef(generateRenderingId())

  // Not getting flicker this way since the variants are pre-rendered on the server
  const TrueVariant = React.useCallback(() => {
    return getVariant({ conditionsMet: true })
  }, [getVariant])

  const FalseVariant = React.useCallback(() => {
    return getVariant({ conditionsMet: false })
  }, [getVariant])

  return (
    <StaticVariantsRendererInline
      className={className}
      renderingId={renderingIdRef.current}
      variants={[
        {
          id: 'matches',
          content: <TrueVariant />,
          conditions,
          isDefault: false,
        },
        {
          id: 'does-not-match',
          content: <FalseVariant />,
          conditions: [],
          isDefault: true,
        },
      ]}
    />
  )
}
